var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoColornow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 234.49 48.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ef5322;\n      }\n\n      .cls-2 {\n        fill: #3b896f;\n      }\n\n      .cls-3 {\n        fill: #f16827;\n      }\n\n      .cls-4 {\n        fill: #6a348a;\n      }\n\n      .cls-5 {\n        fill: #f37d2c;\n      }\n\n      .cls-6 {\n        fill: #7eb84a;\n      }\n\n      .cls-7 {\n        fill: #d74b35;\n      }\n\n      .cls-8 {\n        fill: #f8bc3a;\n      }\n\n      .cls-9 {\n        fill: #52499a;\n      }\n\n      .cls-10 {\n        fill: #bdc33c;\n      }\n\n      .cls-11 {\n        fill: #762a82;\n      }\n\n      .cls-12 {\n        fill: #e4be3b;\n      }\n\n      .cls-13 {\n        fill: #f49230;\n      }\n\n      .cls-14 {\n        fill: #f6a735;\n      }\n\n      .cls-15 {\n        fill: #a63a5c;\n      }\n\n      .cls-16 {\n        fill: #bf4348;\n      }\n\n      .cls-17 {\n        fill: #5e3f92;\n      }\n\n      .cls-18 {\n        fill: #24797c;\n      }\n\n      .cls-19 {\n        fill: #d0c13b;\n      }\n\n      .cls-20 {\n        fill: #8e326f;\n      }\n\n      .cls-21 {\n        fill: #519963;\n      }\n\n      .cls-22 {\n        fill: #3a5eaa;\n      }\n\n      .cls-23 {\n        fill: #4654a2;\n      }\n\n      .cls-24 {\n        fill: #68a856;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m67.65,33.32c-1.54,1.73-3.13,2.51-5.16,2.51-4.32,0-7.11-3.68-7.11-9.38s2.77-9.29,7.24-9.29c1.7,0,3.19.69,4.42,2.06l.19.21,1.2-1.33-.14-.17c-.67-.79-2.57-2.62-5.66-2.62-5.63,0-9.27,4.37-9.27,11.13s3.65,11.22,9.08,11.22c2.59,0,4.64-.98,6.46-3.09l.15-.17-1.2-1.29-.18.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.76,15.31c-5.36,0-8.95,4.46-8.95,11.1s3.6,11.26,8.95,11.26,8.92-4.52,8.92-11.26-3.59-11.1-8.92-11.1Zm0,20.51c-4.2,0-6.92-3.69-6.92-9.41s2.72-9.25,6.92-9.25,6.89,3.63,6.89,9.25-2.77,9.41-6.89,9.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.19 15.7 97.22 15.7 97.22 37.28 108.88 37.28 108.88 35.5 99.19 35.5 99.19 15.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.28,15.31c-5.36,0-8.95,4.46-8.95,11.1s3.6,11.26,8.95,11.26,8.92-4.52,8.92-11.26-3.59-11.1-8.92-11.1Zm0,20.51c-4.2,0-6.92-3.69-6.92-9.41s2.72-9.25,6.92-9.25,6.89,3.63,6.89,9.25-2.77,9.41-6.89,9.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.2,21.51c0-3.86-2.42-5.82-7.19-5.82h-6.27v21.59h1.97v-9.7h4.09l5.7,9.7h2.28l-5.83-9.85c3.35-.58,5.25-2.72,5.25-5.92Zm-11.49-4.07h3.91c3.88,0,5.54,1.22,5.54,4.07s-1.86,4.36-5.54,4.36h-3.91v-8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.57,28.87c0,1.79.07,3.59.16,5.36l-2.03-3.54-8.94-15h-1.93v21.59h1.88v-13.34c0-1.78-.07-3.46-.15-5.2l2.03,3.54,8.94,15h1.93V15.7h-1.88v13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.94,15.31c-5.36,0-8.95,4.46-8.95,11.1s3.6,11.26,8.95,11.26,8.92-4.52,8.92-11.26-3.59-11.1-8.92-11.1Zm0,20.51c-4.2,0-6.92-3.69-6.92-9.41s2.72-9.25,6.92-9.25,6.89,3.63,6.89,9.25-2.77,9.41-6.89,9.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.07,15.7l-2.67,12.62c-.24,1.14-.47,2.28-.7,3.41-.18.88-.36,1.77-.54,2.65-.21-.87-.42-1.74-.64-2.61-.28-1.15-.56-2.3-.84-3.47l-3.38-12.6h-1.86l-3.38,12.61c-.15.62-.29,1.23-.44,1.85-.33,1.38-.67,2.79-.98,4.19l-.07-.33c-.4-1.89-.8-3.8-1.23-5.71l-2.67-12.61h-2.08l4.91,21.59h2.03l3.83-14.66c.16-.7.33-1.36.5-2.02.16-.63.33-1.28.48-1.96.12.53.25,1.05.37,1.57.19.78.37,1.57.57,2.42l3.89,14.65h2.02l4.85-21.59h-1.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m227.67,16.31h-1.21v-.63h3.16v.63h-1.21v3.56h-.74v-3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.78,15.68h.81l.76,2.06.28.79h.03l.28-.79.74-2.06h.82v4.19h-.7v-1.92c0-.39.06-.95.1-1.33h-.03l-.34.96-.72,1.9h-.34l-.72-1.9-.33-.96h-.03c.03.38.09.94.09,1.33v1.92h-.68v-4.19Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 37.33,
    y: 28.62,
    width: 1.14,
    height: 14.09,
    transform: "translate(89.56 29.39) rotate(129.82)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-2",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 34.57,
    y: 31.27,
    width: 1.14,
    height: 14.09,
    transform: "translate(86.36 47.25) rotate(142.42)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-3",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 31.3,
    y: 33.26,
    width: 1.14,
    height: 14.09,
    transform: "translate(77.77 63.38) rotate(155.02)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-4",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 27.67,
    y: 34.49,
    width: 1.14,
    height: 14.09,
    transform: "translate(64.73 76.04) rotate(167.62)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-5",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 23.86,
    y: 34.89,
    width: 1.14,
    height: 14.09,
    transform: "translate(48.7 83.97) rotate(-179.78)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-6",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 20.05,
    y: 34.46,
    width: 1.14,
    height: 14.09,
    transform: "translate(31.53 86.54) rotate(-167.18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-7",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 16.44,
    y: 33.2,
    width: 1.14,
    height: 14.09,
    transform: "translate(15.09 83.9) rotate(-154.58)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-8",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 13.18,
    y: 31.19,
    width: 1.14,
    height: 14.09,
    transform: "translate(1.03 76.82) rotate(-141.98)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-9",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 10.44,
    y: 28.51,
    width: 1.14,
    height: 14.09,
    transform: "translate(-9.49 66.62) rotate(-129.38)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-10",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 8.35,
    y: 25.3,
    width: 1.14,
    height: 14.09,
    transform: "translate(-15.94 54.88) rotate(-116.78)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-11",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 7.01,
    y: 21.72,
    width: 1.14,
    height: 14.09,
    transform: "translate(-18.45 43.15) rotate(-104.18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-12",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 6.48,
    y: 17.92,
    width: 1.14,
    height: 14.09,
    transform: "translate(-17.71 32.71) rotate(-91.58)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-13",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 6.8,
    y: 14.11,
    width: 1.14,
    height: 14.09,
    transform: "translate(-14.8 24.34) rotate(-78.98)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-14",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.94,
    y: 10.45,
    width: 1.14,
    height: 14.09,
    transform: "translate(-10.93 18.28) rotate(-66.38)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-15",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 9.85,
    y: 7.13,
    width: 1.14,
    height: 14.09,
    transform: "translate(-7.17 14.21) rotate(-53.78)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-16",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 12.44,
    y: 4.31,
    width: 1.14,
    height: 14.09,
    transform: "translate(-4.25 11.37) rotate(-41.18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-17",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 15.58,
    y: 2.12,
    width: 1.14,
    height: 14.09,
    transform: "translate(-2.41 8.84) rotate(-28.58)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-18",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 19.12,
    y: 0.67,
    width: 1.14,
    height: 14.09,
    transform: "translate(-1.36 5.72) rotate(-15.98)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-19",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 22.9,
    y: 0.02,
    width: 1.14,
    height: 14.09,
    transform: "translate(-.38 1.39) rotate(-3.38)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-20",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 26.72,
    y: 0.22,
    width: 1.14,
    height: 14.09,
    transform: "translate(1.52 -4.28) rotate(9.22)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-21",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 30.41,
    y: 1.24,
    width: 1.14,
    height: 14.09,
    transform: "translate(5.3 -10.93) rotate(21.82)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-22",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 33.79,
    y: 3.05,
    width: 1.14,
    height: 14.09,
    transform: "translate(11.72 -17.66) rotate(34.42)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-23",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 36.7,
    y: 5.55,
    width: 1.14,
    height: 14.09,
    transform: "translate(21.07 -23.26) rotate(47.02)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-24",
    "data-name": "&lt;Radial Repeat&gt;"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 38.98,
    y: 8.62,
    width: 1.14,
    height: 14.09,
    transform: "translate(33.06 -26.38) rotate(59.62)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColornow);
export default __webpack_public_path__ + "static/media/logo-colornow.02be6e5475a5915526d2608cf7be5c19.svg";
export { ForwardRef as ReactComponent };